import { AppSettings } from '../app.settings';
import { AssignDriverScreenFiltersDataModel } from './assign-driver-screen-filters-data-model';

export class AssignDriverScreenFilterModel {
    screenCode: String = AppSettings.FILTER_SCREEN_CODE.VEHICLES_SCREEN;
    /** Filters are saved per user + screen + event; the backend rejects a save without it. */
    eventId?: String;
    filterData: AssignDriverScreenFiltersDataModel = new AssignDriverScreenFiltersDataModel();

    constructor(options?: {
        screenCode?: String,
        eventId?: String,
        filterData: AssignDriverScreenFiltersDataModel
    }) {
        if (options) {
            this.screenCode = options.screenCode;
            this.eventId = options.eventId;
            this.filterData = options.filterData;
        }
    }
};
